import React, { useEffect } from "react";
import { useEquipmentV2Selector } from "../../../redux/store";
import { useEquipmentLabel, useEquipmentOptionalLabel } from "../../../utils/labels";
import Equipment from "../common/Equipment";
import useStatus from "../../../../../../common-deprecated/hooks/useStatus";
import useEquipmentColourPostal from "../../../hooks/useEquipmentColourPostal";
import { useModalMap } from "../../../../../../common-deprecated/containers/ModalProvider";
import { aemLexusCommonModalMap } from "../../../../../../common-deprecated/components/modals/aem/lexus/modals";
import { updateTrackingLayerVersioning } from "../../../utils/tracking";

const StandardEquipment = (): JSX.Element | null => {
    const equipment = useEquipmentV2Selector((state) => state.equipment);
    const settings = useEquipmentV2Selector((state) => state.commonSettings);
    const standardEquipmentTitle = useEquipmentLabel("standardEquipmentTitle");
    const standardEquipmentDescription = useEquipmentOptionalLabel("standardEquipmentDescription");

    useEquipmentColourPostal();
    useModalMap(aemLexusCommonModalMap);
    useStatus(settings, "AEM Equipment");
    useEffect(() => {
        updateTrackingLayerVersioning();
    }, []);

    if (!equipment.loaded || equipment.error || !equipment.standard.length) return null;
    return (
        <Equipment
            equipmentLabels={[standardEquipmentTitle, standardEquipmentDescription]}
            equipment={equipment.standard}
        />
    );
};

export default StandardEquipment;
